import { categories } from '../constants';
import { MedisanteOrgReport } from '../types';

export const getBatteryHealthData = (
  reports: MedisanteOrgReport[],
  avg: boolean = false
) => {
  const ok = reports.reduce(
    (agg, report) => agg + (avg ? report.batteryAverageOK : report.batteryOK),
    0
  );
  const warning = reports.reduce(
    (agg, report) =>
      agg + (avg ? report.batteryAverageWarning : report.batteryWarning),
    0
  );
  const critical = reports.reduce(
    (agg, report) =>
      agg + (avg ? report.batteryAverageCritical : report.batteryCritical),
    0
  );
  return {
    totalCount: ok + warning + critical,
    okCount: ok,
    warningCount: warning,
    criticalCount: critical,
    chartData: [
      {
        name: categories.OK.name,
        key: categories.OK.value,
        val: ok,
      },
      {
        name: categories.WARNING.name,
        key: categories.WARNING.value,
        val: warning,
      },
      {
        name: categories.CRITICAL.name,
        key: categories.CRITICAL.value,
        val: critical,
      },
    ],
  };
};
